import React from 'react';
import { Card, Descriptions } from 'antd';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import DateDisplay from '../../../../layout/DateDisplay';
import { GET_REPORT_SUBMISSIONS } from '../../../../../gql/reportSubmissions';
import { formatEnum } from '../../../../../utils';

const ScheduledReportSubmissionDetail = () => {
  const { id } = useParams();
  const { data, loading } = useQuery(GET_REPORT_SUBMISSIONS, {
    variables: { ids: [id] },
  });
  const reportSubmission = data?.reportSubmissions[0];

  return (
    <Card title="Scheduled Report Submission" loading={loading}>
      <Descriptions>
        <Descriptions.Item label="Report Type" span={3}>
          {formatEnum(reportSubmission?.reportType)}
        </Descriptions.Item>
        <Descriptions.Item label="Scheduled Submission Date" span={3}>
          <DateDisplay date={reportSubmission?.scheduledSubmissionDate} />
        </Descriptions.Item>
        <Descriptions.Item label="Reporting Period" span={3}>
          {reportSubmission?.reportingPeriod}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default ScheduledReportSubmissionDetail;
